import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div className="Preloader">
      <div className="spinner" />
    </div>
  );
};

export default Preloader;
